(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.ConfiguratorRules = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  function asArray(value) {
    if (!value) return [];
    return (Array.isArray(value) ? value : [value]).filter(Boolean);
  }

  function selectionFor(selections, componentHandle) {
    const read = key => selections instanceof Map ? selections.get(key) : selections?.[key];
    return [
      ...asArray(read(componentHandle)),
      ...asArray(read(`${componentHandle}-optional`))
    ];
  }

  function normalizeIds(values) {
    return asArray(values)
      .map(Number)
      .filter(Number.isFinite);
  }

  function matchingSelections(selections, componentHandle, variantIds) {
    const selected = selectionFor(selections, componentHandle);
    const ids = normalizeIds(variantIds);
    if (!ids.length) return selected;
    const allowed = new Set(ids);
    return selected.filter(variant => allowed.has(Number(variant.id)));
  }

  function unavailableSelections(selections) {
    const values = selections instanceof Map
      ? Array.from(selections.values())
      : Object.values(selections || {});

    return values
      .flatMap(asArray)
      .filter(variant => variant && variant.available === false);
  }

  function automaticRequirements({ triggerComponent, triggerVariant, requirements = [] } = {}) {
    if (!triggerComponent || !triggerVariant) return [];
    const triggerVariantId = Number(triggerVariant.id);

    return requirements.filter(requirement => {
      if (!requirement.auto_apply || requirement.trigger_component !== triggerComponent) return false;
      const triggerIds = normalizeIds(requirement.trigger_variants);
      return !triggerIds.length || triggerIds.includes(triggerVariantId);
    });
  }

  function evaluate({ selections, conflicts = [], requirements = [] } = {}) {
    const activeConflicts = [];
    const unmetRequirements = [];

    conflicts.forEach(conflict => {
      const component1Selections = matchingSelections(
        selections,
        conflict.component1,
        conflict.component1_variants
      );
      const component2Selections = matchingSelections(
        selections,
        conflict.component2,
        conflict.component2_variants
      );

      if (component1Selections.length && component2Selections.length) {
        activeConflicts.push({
          ...conflict,
          component1Selections,
          component2Selections
        });
      }
    });

    requirements.forEach(requirement => {
      const triggerSelections = matchingSelections(
        selections,
        requirement.trigger_component,
        requirement.trigger_variants
      );
      if (!triggerSelections.length) return;

      const requiredSelections = matchingSelections(
        selections,
        requirement.required_component,
        requirement.required_component_variants
      );
      if (!requiredSelections.length) {
        unmetRequirements.push({
          ...requirement,
          triggerSelections
        });
      }
    });

    return {
      activeConflicts,
      unmetRequirements,
      hasBlockingIssue: activeConflicts.length > 0 || unmetRequirements.length > 0
    };
  }

  return {
    evaluate,
    matchingSelections,
    selectionFor,
    unavailableSelections,
    automaticRequirements
  };
});
